export default __webpack_public_path__ + "static/media/fibre7.b9e37af6.jpeg";